export default {
      id: "icon--google-usage",
      viewBox: "0 0 500 166",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--google-usage",
      toString: function () {
        return this.url;
      }
    }